<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { api } from "../api";
const route = useRoute();
const item = ref<Record<string, unknown> | null>(null);
const error = ref("");
onMounted(async () => { try { item.value = await api.product(String(route.params.id)); } catch (e) { error.value = (e as Error).message; } });
</script>

<template>
  <div v-if="error" class="error">{{ error }}</div>
  <div v-else class="grid" style="grid-template-columns: 2fr 1fr">
    <div class="panel"><h2>商品主档</h2><el-descriptions v-if="item" :column="2" border><el-descriptions-item v-for="(value,key) in item" :key="key" :label="String(key)">{{ value }}</el-descriptions-item></el-descriptions></div>
    <div class="panel"><h2>系统映射</h2><p class="muted">CRMEB、ERPNext 与客服系统的外部 ID 将在这里集中维护，并保留同步审计。</p></div>
  </div>
</template>
